"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;

var _reduxImmutable = require("redux-immutable");

var _immutable = require("connected-react-router/immutable");

var _immutable2 = require("immutable");

var _history = _interopRequireDefault(require("./utils/history"));

var _globalReducer = _interopRequireDefault(require("./globalReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var routeInitialState = (0, _immutable2.fromJS)({
  location: null
});

function routeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : routeInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _immutable.LOCATION_CHANGE:
      return state.merge({
        location: action.payload
      });

    default:
      return state;
  }
}
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */


function createReducer() {
  var injectedReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rootReducer = (0, _reduxImmutable.combineReducers)(_objectSpread({
    router: routeReducer,
    global: _globalReducer.default
  }, injectedReducers)); // Wrap the root reducer and return a new root reducer with router state

  var mergeWithRouterState = (0, _immutable.connectRouter)(_history.default);
  return mergeWithRouterState(rootReducer);
}